import { trackCsEvent, trackPropertyInfoCsEvent } from 'app/client/analytics';
import { getEnvelope, getPropertyInfo } from 'app/client/analytics/utils';
import { store } from 'app/shared/flux/store/configureStore';

// https://dataportal.zillowgroup.net/event-registry/4785
export const emitTrackViewHdpEvent = () => {
  const state = store.getState();
  const isChatGPT = state.app.isChatGPT || false;

  // Route to agentic tracking for agentic browsers
  if (isChatGPT) {
    return emitTrackAgenticViewHdpEvent();
  }

  // Standard human user tracking
  const listing = state.currentListingDetails.currentListing;

  trackPropertyInfoCsEvent({
    envelope: getEnvelope({ eventId: '4785', eventVersion: '2', templateId: '285', templateVersion: '1' }),
    clickstream_trigger: {
      trigger_type_nm: 'view',
      trigger_location_nm: 'home_details',
      trigger_source_nm: 'home_details',
      trigger_object_nm: 'no_trigger_object',
    },
    semantic: {
      semantic_event_nm: 'view_content',
      topic_tag_txt: [],
    },
    ...getPropertyInfo(listing),
  });
};

// https://dataportal.zillowgroup.net/event-registry/8470
export const emitTrackAgenticViewHdpEvent = () => {
  trackCsEvent({
    envelope: getEnvelope({
      eventId: '8470',
      eventVersion: '3',
      templateId: '381',
      templateVersion: '1',
    }),
    clickstream_trigger: {
      trigger_type_nm: 'view',
      trigger_location_nm: 'home_details',
      trigger_source_nm: 'home_details',
      trigger_object_nm: 'no_trigger_object',
    },
    semantic: {
      semantic_event_nm: 'view_content',
      topic_tag_txt: [],
    },
  });
};

// https://dataportal.zillowgroup.net/event-registry/5719
export const emitTrackViewHomepageEvent = () => {
  trackCsEvent({
    envelope: getEnvelope({ eventId: '5719', eventVersion: '1', templateId: '171', templateVersion: '1' }),
    clickstream_trigger: {
      trigger_type_nm: 'view',
      trigger_location_nm: 'hp_homepage',
      trigger_source_nm: 'hp_homepage',
      trigger_object_nm: 'no_trigger_object',
    },
    semantic: {
      semantic_event_nm: 'view_content',
      topic_tag_txt: [],
    },
  });
};

// JE todo - DONE - SEE @app/shared/pages/MyHubPage/index.js
// https://dataportal.zillowgroup.net/event-registry/6207
export const emitTrackViewMyHubEvent = () => {
  trackCsEvent({
    envelope: getEnvelope({ eventId: '6207', eventVersion: '1', templateId: '171', templateVersion: '1' }),
    clickstream_trigger: {
      trigger_type_nm: 'view',
      trigger_location_nm: 'my_hub_page',
      trigger_source_nm: 'my_hub_page',
      trigger_object_nm: 'no_trigger_object',
    },
    semantic: {
      semantic_event_nm: 'view_content',
      topic_tag_txt: [],
    },
  });
};

// JE todo - DONE - SEE @app/shared/pages/SavedSearchPage/index.js
// https://dataportal.zillowgroup.net/event-registry/6208
export const emitTrackViewSearchAlertsPageEvent = () => {
  trackCsEvent({
    envelope: getEnvelope({ eventId: '6208', eventVersion: '1', templateId: '171', templateVersion: '1' }),
    clickstream_trigger: {
      trigger_type_nm: 'view',
      trigger_location_nm: 'search_alerts_page',
      trigger_source_nm: 'search_alerts_page',
      trigger_object_nm: 'no_trigger_object',
    },
    semantic: {
      semantic_event_nm: 'view_content',
      topic_tag_txt: [],
    },
  });
};

// https://dataportal.zillowgroup.net/event-registry/6209
export const emitTrackViewLoginPageEvent = () => {
  trackCsEvent({
    envelope: getEnvelope({ eventId: '6209', eventVersion: '1', templateId: '171', templateVersion: '1' }),
    clickstream_trigger: {
      trigger_type_nm: 'view',
      trigger_location_nm: 'login_screen',
      trigger_source_nm: 'login_screen',
      trigger_object_nm: 'no_trigger_object',
    },
    semantic: {
      semantic_event_nm: 'view_content',
      topic_tag_txt: [],
    },
  });
};

// https://dataportal.zillowgroup.net/event-registry/6210
export const emitTrackViewUserAccountPageEvent = () => {
  trackCsEvent({
    envelope: getEnvelope({ eventId: '6210', eventVersion: '1', templateId: '171', templateVersion: '1' }),
    clickstream_trigger: {
      trigger_type_nm: 'view',
      trigger_location_nm: 'user_account_page',
      trigger_source_nm: 'user_account_page',
      trigger_object_nm: 'no_trigger_object',
    },
    semantic: {
      semantic_event_nm: 'view_content',
      topic_tag_txt: [],
    },
  });
};

// https://dataportal.zillowgroup.net/event-registry/6211
export const emitTrackViewMyListPageEvent = () => {
  trackCsEvent({
    envelope: getEnvelope({ eventId: '6211', eventVersion: '2', templateId: '171', templateVersion: '1' }),
    clickstream_trigger: {
      trigger_type_nm: 'view',
      trigger_location_nm: 'user_item_list_page',
      trigger_source_nm: 'user_item_list_page',
      trigger_object_nm: 'no_trigger_object',
    },
    semantic: {
      semantic_event_nm: 'view_content',
      topic_tag_txt: [],
    },
  });
};

// https://dataportal.zillowgroup.net/event-registry/6212
export const emitTrackViewViewedListingsPageEvent = () => {
  trackCsEvent({
    envelope: getEnvelope({ eventId: '6212', eventVersion: '1', templateId: '171', templateVersion: '1' }),
    clickstream_trigger: {
      trigger_type_nm: 'view',
      trigger_location_nm: 'user_item_viewed_page',
      trigger_source_nm: 'user_item_viewed_page',
      trigger_object_nm: 'no_trigger_object',
    },
    semantic: {
      semantic_event_nm: 'view_content',
      topic_tag_txt: [],
    },
  });
};

// https://dataportal.zillowgroup.net/event-registry/6213
export const emitTrackViewHiddenListingsPageEvent = () => {
  trackCsEvent({
    envelope: getEnvelope({ eventId: '6213', eventVersion: '1', templateId: '171', templateVersion: '1' }),
    clickstream_trigger: {
      trigger_type_nm: 'view',
      trigger_location_nm: 'user_item_viewed_page',
      trigger_source_nm: 'user_item_viewed_page',
      trigger_object_nm: 'no_trigger_object',
    },
    semantic: {
      semantic_event_nm: 'view_content',
      topic_tag_txt: [],
    },
  });
};

// Dave
// https://dataportal.zillowgroup.net/event-registry/6214
type SettingsPageTriggers = 'edit_profile_page' | 'renter_profile' | 'edit_settings_page';
export const emitTrackViewSettingsPageEvent = ({
  triggerLocation,
  triggerSource,
}: {
  triggerLocation: SettingsPageTriggers;
  triggerSource: SettingsPageTriggers;
}) => {
  trackCsEvent({
    envelope: getEnvelope({ eventId: '6214', eventVersion: '1', templateId: '171', templateVersion: '1' }),
    clickstream_trigger: {
      trigger_type_nm: 'view',
      trigger_location_nm: triggerLocation,
      trigger_source_nm: triggerSource,
      trigger_object_nm: 'no_trigger_object',
    },
    semantic: {
      semantic_event_nm: 'view_content',
      topic_tag_txt: [],
    },
  });
};

// https://dataportal.zillowgroup.net/event-registry/5720
export const emitTrackViewSrpEvent = () => {
  const state = store.getState();
  const isChatGPT = state.app.isChatGPT || false;

  // Route to agentic tracking for agentic browsers
  if (isChatGPT) {
    return emitTrackAgenticViewSrpEvent();
  }

  trackCsEvent({
    envelope: getEnvelope({ eventId: '5720', eventVersion: '1', templateId: '171', templateVersion: '1' }),
    clickstream_trigger: {
      trigger_type_nm: 'view',
      trigger_location_nm: 'search_results',
      trigger_source_nm: 'search_results',
      trigger_object_nm: 'no_trigger_object',
    },
    semantic: {
      semantic_event_nm: 'view_content',
      topic_tag_txt: [],
    },
  });
};

// https://dataportal.zillowgroup.net/event-registry/8470
export const emitTrackAgenticViewSrpEvent = () => {
  trackCsEvent({
    envelope: getEnvelope({
      eventId: '8470',
      eventVersion: '3',
      templateId: '381',
      templateVersion: '1',
    }),
    clickstream_trigger: {
      trigger_type_nm: 'view',
      trigger_location_nm: 'search_results',
      trigger_source_nm: 'search_results',
      trigger_object_nm: 'no_trigger_object',
    },
    semantic: {
      semantic_event_nm: 'view_content',
      topic_tag_txt: [],
    },
  });
};
